import React, {Component} from "react";
import {Translate} from "react-i18nify";

import * as config from "../../../constants/config";

import FlashMessage from "../../global/FlashMessage";

export default class NotificationPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showMore: false
        };
    }

    getAllNotifications = () => {
        let item,
            key,
            listOfItems = [];

        for (item of this.props.notificationList) {
            key = this.props.notificationList.indexOf(item);
            listOfItems.push(
                <li key={key}>
                    <FlashMessage index={key} type={item.type} text={item.text} />
                </li>
            );
        }
        return listOfItems;
    };

    handleShowMoreButtonClick = () => {
        this.state.showMore === false ? this.setState({showMore: true}) : this.setState({showMore: false});
    };

    getNotificationButton = () => {
        if (this.props.notificationList.length > config.FLASH_MESSAGES_PANEL_LIMIT) {
            if (this.state.showMore)
                return (
                    <button className="color-primary" onClick={this.handleShowMoreButtonClick}>
                        <Translate value="flashMessage.showLess" />
                    </button>
                );
            return (
                <button className="color-primary" onClick={this.handleShowMoreButtonClick}>
                    <span>
                        <Translate value="flashMessage.showMore" /> (
                        {this.props.notificationList.length - config.FLASH_MESSAGES_PANEL_LIMIT})
                    </span>
                </button>
            );
        }
        return "";
    };

    handleDeleteAllButtonClick = () => {
        this.props.deleteAllFlashMessages();
        this.setState({showMore: false});
    };

    getDeleteAllButton = () => {
        if (this.props.notificationList.length > 1) {
            return (
                <button className="color-primary pull-right" onClick={this.handleDeleteAllButtonClick}>
                    <Translate value="flashMessage.deleteAll" />
                </button>
            );
        }

        return "";
    };

    getNotificationList = () => {
        if (this.props.notificationList.length > 0) {
            if (this.state.showMore === true) {
                return <ul className="flash-message-history">{this.getAllNotifications()}</ul>;
            }
            return (
                <ul className="flash-message-history">
                    {this.getAllNotifications().slice(0, config.FLASH_MESSAGES_PANEL_LIMIT)}
                </ul>
            );
        }
        return (
            <div className="no-notification color-primary">
                <Translate value="navigation.notificationPanel.noNotifications" />
            </div>
        );
    };

    render() {
        if (!this.props.activeNotificationPanel) {
            return "";
        }

        return (
            <div className="notification-panel">
                <div className="messages-panel slim-scroll">{this.getNotificationList()}</div>
                <div className="btn-row show-more">
                    {this.getNotificationButton()}
                    {this.getDeleteAllButton()}
                </div>
            </div>
        );
    }
}
